var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifcationIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3724 11.4372L12.16 11.2211V7.20225C12.1458 4.27093 9.97918 1.85098 7.19651 1.49807V0.720225C7.19651 0.324101 6.87788 0 6.48845 0C6.09902 0 5.78039 0.324101 5.78039 0.720225V1.49807C4.5342 1.65652 3.38007 2.21829 2.48083 3.14018C1.41166 4.22772 0.823973 5.68258 0.823973 7.22386V11.2283L0.625716 11.4372C0.0097038 12.0638 -0.167311 12.9641 0.165477 13.7923C0.498265 14.6134 1.24881 15.1247 2.1268 15.1247H10.8713C11.7423 15.1247 12.4928 14.6134 12.8327 13.7923C13.1655 12.9713 12.9955 12.071 12.3795 11.4372H12.3724ZM11.5157 13.2377C11.4732 13.3386 11.3033 13.6771 10.8643 13.6771H2.11972C1.68072 13.6771 1.51079 13.3386 1.46831 13.2305C1.42582 13.1297 1.31253 12.7624 1.62408 12.4455L2.03475 12.0278C2.16929 11.8909 2.24009 11.7109 2.24009 11.5164V7.21666C2.23301 6.05709 2.67201 4.96955 3.4792 4.1557C4.2793 3.33464 5.34847 2.8881 6.48845 2.8881C8.83213 2.8881 10.7368 4.82551 10.7368 7.20945V11.5308C10.7439 11.7181 10.8147 11.9053 10.9492 12.035L11.367 12.4599C11.6785 12.7768 11.5582 13.1369 11.5157 13.2449V13.2377Z",
    fill: "#393B4A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifcationIcon);
export default __webpack_public_path__ + "static/media/notifcationIcon.e086cadc823362d23976185b08675579.svg";
export { ForwardRef as ReactComponent };